// @ts-nocheck
import { SassWorker } from "types";

var noop = function () { };
var slice = [].slice;
// defined upon first Sass.initialize() call
var globalWorkerUrl;

function Sass(workerUrl) {
  if (!workerUrl && !globalWorkerUrl) {
    /*jshint laxbreak:true */
    throw new Error(
      'Sass needs to be initialized with the URL of sass.worker.js - '
      + 'either via Sass.setWorkerUrl(url) or by new Sass(url)'
    );
    /*jshint laxbreak:false */
  }

  if (!globalWorkerUrl) {
    globalWorkerUrl = workerUrl;
  }

  // bind all functions
  // we're doing this because we used to have a single hard-wired instance that allowed
  // [].map(Sass.removeFile) and we need to maintain that for now (at least until 1.0.0)
  for (var key in this) {
    if (typeof this[key] === 'function') {
      this[key] = this[key].bind(this);
    }
  }

  this._callbacks = {};
  this._worker = new Worker(workerUrl || globalWorkerUrl);
  this._worker.addEventListener('message', this._handleWorkerMessage, false);
}

// allow setting the workerUrl before the first Sass instance is initialized,
// where registering the global workerUrl would've happened automatically
Sass.setWorkerUrl = function (workerUrl) {
  globalWorkerUrl = workerUrl;
};

Sass.style = {
  nested: 0,
  expanded: 1,
  compact: 2,
  compressed: 3
};

Sass.comments = {
  'none': 0,
  'default': 1
};

Sass.prototype = {
  style: Sass.style,
  comments: Sass.comments,

  destroy: function () {
    this._worker && this._worker.terminate();
    this._worker = null;
    this._callbacks = {};
    this._importer = null;
  },

  _handleWorkerMessage: function (event) {
    if (event.data.command) {
      this[event.data.command](event.data.args);
    }

    this._callbacks[event.data.id] && this._callbacks[event.data.id](event.data.result);
    delete this._callbacks[event.data.id];
  },

  _dispatch: function (options, callback) {
    if (!this._worker) {
      throw new Error('Sass worker has been terminated');
    }

    options.id = 'cb' + Date.now() + Math.random();
    this._callbacks[options.id] = callback;
    this._worker.postMessage(options);
  },

  _importerInit: function (args) {
    // importer API done callback pushing results
    // back to the worker
    var done = function done(result) {
      this._worker.postMessage({
        command: '_importerFinish',
        args: [result]
      });
    }.bind(this);

    try {
      this._importer(args[0], done);
    } catch (e) {
      done({ error: e.message });
      throw e;
    }
  },

  importer: function (importerCallback, callback) {
    if (typeof importerCallback !== 'function' && importerCallback !== null) {
      throw new Error('importer callback must either be a function or null');
    }

    // callback is executed in the main EventLoop
    this._importer = importerCallback;
    // tell worker to activate importer callback
    this._worker.postMessage({
      command: 'importer',
      args: [Boolean(importerCallback)]
    });

    callback && callback();
  },
};

var commands = 'writeFile readFile listFiles removeFile clearFiles lazyFiles preloadFiles options compile compileFile';
commands.split(' ').forEach(function (command) {
  Sass.prototype[command] = function () {
    var callback = slice.call(arguments, -1)[0];
    var args = slice.call(arguments, 0, -1);
    if (typeof callback !== 'function') {
      args.push(callback);
      callback = noop;
    }

    this._dispatch({
      command: command,
      args: args
    }, callback);
  };
});

let sass: SassWorker;

export const getSassWorker = (workerUrl: string, initialize?: boolean): SassWorker => {
  if (sass)
    return sass;

  if (process.env.NODE_ENV === "development" && process.env.VITE) {
    sass = new Sass(workerUrl);
  } else {
    const objectURL = URL.createObjectURL(
      new Blob([`importScripts(${JSON.stringify(workerUrl)});`], {
        type: "application/javascript"
      })
    );
    sass = new Sass(objectURL);
    URL.revokeObjectURL(objectURL);
  }

  // This is starting starts webworker, it takes time because sass.worker.js is nearly 5Mb
  // It should be started on app load as early as possible, hopefully it's up and running before transpile of sandbox begins
  // If transpiler calls sass.compile before worker is ready, sass automatically waits so there is no harm, but the first transpile will be longer.
  if (initialize)
    sass.compile(".test{color:white}", (result) => console.debug(`Sass worker initialize. Status=${result.status}. ${result.message || ""}`,));

  return sass;
};

export const compileSass = async (contents: string, options: SassOptions): Promise<CompileResult> => {
  return new Promise(async (resolve, reject) => {
    if (!contents)
      resolve("");

    try {
      const sass = getSassWorker(globalWorkerUrl);
      sass.compile(contents, options, (result) => resolve(result));
    } catch (error) {
      reject(error);
    }
  });
};
